import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, Menu } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tagMenu: {
    '& .MuiPaper-root': {
      borderRadius: '0.625rem',
      boxShadow: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.1)',
      width: '13.313rem',
      padding: '0.625rem 0.313rem',
    },
    '& .MuiList-padding': {
      padding: '0',
    },
    '& .MuiListItem-gutters': {
      paddingLeft: '0.625rem',
    },
  },
  tagsItem: {
    width: '12.688rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    height: '2.813rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#f5faff',
      color: theme.palette.primary.main,
    },
  },
}));

// anchorEl傳入位置，open控制組件開關，onClose組件關閉事件，數組itemList放下拉框item的信息，bodyStyle控制組件位置
export default function DropSelectBox({ anchorEl, open, onClose, itemList, bodyStyle }) {
  const classes = useStyles();
  return (
    <Menu className={classes.tagMenu} anchorEl={anchorEl} open={open} onClose={onClose} style={bodyStyle} keepMounted>
      {itemList.map((item, index) => (
        <MenuItem className={classes.tagsItem} onClick={item.handleClick} key={item.text}>
          {item.text}
        </MenuItem>
      ))}
    </Menu>
  );
}
